import { DefaultPage, CreateWebhook, UpdateWebhook } from './';

export default {
  path: 'webhook/:version/v',
  name: 'Webhook',
  childRoutes: [
    { path: ':projectId/', name: 'Default page', component: DefaultPage, isPrivate: true },
    {
      path: ':projectId/create',
      name: 'Create webhook',
      component: CreateWebhook,
      isPrivate: true,
    },
    {
      path: ':projectId/edit/:webhookId',
      name: 'Update webhook',
      component: UpdateWebhook,
      isPrivate: true,
    },
  ],
};
